import React from "react";
import {
    Box,
    Chip,
    IconButton,
    Paper,
    Stack,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {
    DragIndicator as DragIcon,
    RemoveCircle as RemoveIcon,
} from "@mui/icons-material";

import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const getStopType = (index, total) => {
    if (index === 0) return "ORIGEN";
    if (index === total - 1) return "DESTINO";
    return "INTERMEDIA";
};

const getStopColor = (type) => {
    if (type === "ORIGEN") return "success";
    if (type === "DESTINO") return "error";
    return "info";
};

const SortableStopItem = ({ stop, index, total, onRemove, onTimeChange }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: stop.locid });

    const type = getStopType(index, total);

    return (
        <Paper
            ref={setNodeRef}
            variant="outlined"
            sx={{
                p: 1.5,
                mb: 1.2,
                borderRadius: 2,
                backgroundColor: isDragging ? "#f8fafc" : "#fff",
                borderColor: isDragging ? "primary.main" : "#e0e0e0",
                boxShadow: isDragging ? "0 6px 18px rgba(15,23,42,0.16)" : "none",
                transform: CSS.Transform.toString(transform),
                transition,
            }}
        >
            <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" spacing={1} alignItems="center" minWidth={0}>
                        <Box
                            {...attributes}
                            {...listeners}
                            sx={{
                                display: "flex",
                                cursor: "grab",
                                color: "text.secondary",
                            }}
                        >
                            <DragIcon fontSize="small" />
                        </Box>

                        <Box minWidth={0}>
                            <Typography variant="body2" fontWeight="bold" noWrap>
                                #{index + 1} · {stop.locnom}
                            </Typography>

                            <Chip
                                size="small"
                                label={type}
                                color={getStopColor(type)}
                                variant="outlined"
                                sx={{ mt: 0.5, fontWeight: "bold" }}
                            />
                        </Box>
                    </Stack>

                    <Tooltip title="Quitar parada">
                        <IconButton color="error" size="small" onClick={() => onRemove(stop)}>
                            <RemoveIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Stack>

                <DateTimePicker
                    label="Fecha y hora estimada"
                    value={stop.parhorest ? new Date(stop.parhorest) : null}
                    onChange={(newValue) =>
                        onTimeChange(
                            stop.locid,
                            newValue && !Number.isNaN(newValue.getTime())
                                ? newValue.toISOString()
                                : null
                        )
                    }
                    renderInput={(params) => (
                        <TextField {...params} size="small" fullWidth />
                    )}
                />
            </Stack>
        </Paper>
    );
};

export default SortableStopItem;